import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back! No wahala.");
      if (user.role === "admin") navigate("/admin");
      else if (!user.onboarded) navigate("/onboarding");
      else navigate("/app");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-zinc-950">
        <img src="https://images.unsplash.com/photo-1547076286-60c93f1a3652?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="" className="h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white bg-gradient-to-t from-zinc-950 to-transparent">
          <h2 className="font-display text-3xl font-bold">Your car. Your safety.</h2>
          <p className="mt-2 text-emerald-400 font-semibold">No wahala.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm vp-fade-up">
          <Link to="/"><Logo /></Link>
          <h1 className="mt-8 font-display text-3xl font-bold tracking-tight">Welcome back</h1>
          <p className="mt-1 text-sm text-muted-foreground">Log in to check on your car.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                className="mt-1.5 h-12 rounded-xl" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
                className="mt-1.5 h-12 rounded-xl" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full h-12 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-base">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Log in"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-muted-foreground">
            New here? <Link to="/register" className="font-semibold text-emerald-600">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
